import StoryboardDataStore from "@storyboards/modules/storyboardDataStore/storyboardDataStore.service";
import User from "@storyboards/modules/services/user.service";
import { JwtHighbondClient } from "@acl-services/jwt-highbond-client";

export default class QueryClient {
  static jwtClient = new JwtHighbondClient();

  static query(queryObj) {
    const isStoryboardPublicLink = User.isAnonymous();
    const querySlug = isStoryboardPublicLink ? { "X-Storyboard-Slug": StoryboardDataStore.getUid() } : {};
    const queryUrl = this.getQueryUrl();

    return this.jwtClient
      .fetchWithTokenRefresh(queryUrl, {
        method: "POST",
        credentials: "include",
        headers: {
          "content-type": "application/json",
          ...querySlug,
        },
        body: JSON.stringify({
          query: queryObj.query,
          variables: queryObj.variables,
        }),
      })
      .then(response => response.json());
  }

  static getBaseUrl() {
    return window.location.href;
  }

  static getQueryUrl() {
    const baseUrl = this.getBaseUrl();
    const matchLocal = baseUrl.match(/^(http:\/\/localhost)([^/]*)/);

    if (matchLocal) {
      return "http://localhost:8000/graphql";
    } else {
      const match = baseUrl.match(/^(https?:[^\.]+)\.([^\.]+)\.([^/]+)/);
      if (!match) {
        throw `Unable to parse window.location.href URL: ${location}`;
      }

      const urlSuffix = match[3];
      const [, , govSuffix, subDomain] = urlSuffix.match(/^(highbond)(-gov|-gov2|-gov3|-mil)?(-..)?/);
      const isGovCloud = govSuffix || urlSuffix === "highbond.mil";

      if (subDomain === "-s3") {
        /* Playground */
        return "https://query-us2-main.highbond-s3.com/graphql";
      } else if (subDomain === "-s2") {
        /* Preprod */
        return "https://query-us-main.highbond-s2.com/graphql";
      } else if (subDomain === "-s1") {
        /* Staging and staging gov cloud */
        return isGovCloud
          ? `https://query-usg-gov.${urlSuffix}/graphql`
          : `https://query-us2-main.${urlSuffix}/graphql`;
      } else {
        if (isGovCloud) {
          /* Production gov cloud and gov cloud SLED */
          return `https://query.${urlSuffix}/graphql`;
        } else {
          /* Production regions others*/
          const region = match[2].match(/^(results|storyboards|picasso)(-..)?$/);
          const regionSuffix = region && region[2] ? region[2] : "-us";
          return `https://query${regionSuffix}-main.${urlSuffix}/graphql`;
        }
      }
    }
  }
}
